<template>

    <simple-layout
        :indicators="[{'title': nbGroups, 'subtitle': getVerbose('group_simple_layout_indicator_subtitle')}]"
        :models-loaded="true"
        :name="getVerbose('group_simple_layout_indicator_breadcrumb')"
        class="user-management"
    >
        <div class="user-management-group">

            <ns-loader
                :toLoad="[{name: 'users', model: 'users', filters: {ordering: 'verbose_name'}}]"
                @dataFetched="onDataFetched"
            >
                <div slot="loader"></div>
                <div slot="content">
                    <h2>{{ getVerbose('group_page_title') }}</h2>
                    <el-button
                        v-if="enableCreateGroup"
                        type="primary"
                        class="add-button"
                        @click="openModalCreateGroup"
                    >
                        <i class="el-icon-plus"></i> {{ getVerbose('group_button_add_group') }}
                    </el-button>
                    <ns-paginate
                        ref="groupPaginate"
                        v-model="groups"
                        baseUrl="group/"
                        :filters="nsPaginateFilter"
                        :selectWitdh="{ xs: 24, sm: 24, md: 24, lg: 24, xl: 24 }"
                        :customFiltersToApply="customFiltersToApply"
                        :displayCsvButton="enableDownloadCsvGroups"
                    >
                        <div slot="list"
                             slot-scope="props"
                        >
                            <el-table
                                :data="props.list"
                                style="width: 100%"
                            >
                                <el-table-column
                                    :label="getVerbose('group_ns_paginate_label_group_name')"
                                    prop="name"
                                >
                                </el-table-column>
                                <el-table-column
                                    :label="getVerbose('group_ns_paginate_label_members_number')"
                                    width="100px"
                                >
                                    <template slot-scope="scope">
                                        {{ scope.row.members_uid.length }}
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    :label="getVerbose('group_ns_paginate_label_actions')"
                                    width="200px"
                                >
                                    <template slot-scope="scope">
                                        <el-button-group>
                                            <el-button
                                                v-tooltip.top="getVerbose('group_ns_paginate_actions_add_user_tooltip')"
                                                type="primary"
                                                icon="ti-user"
                                                @click="openModalpatchGroup(scope.row, true)"
                                            ><i class="ti-plus" /></el-button>
                                            <el-button
                                                v-tooltip.top="getVerbose('group_ns_paginate_actions_edit_group_tooltip')"
                                                type="primary"
                                                icon="ti-pencil"
                                                @click="updateGroupName(scope.row)"
                                            ></el-button>
                                            <el-button
                                                v-tooltip.top="getVerbose('group_ns_paginate_actions_delete_group_tooltip')"
                                                v-if="enableDeleteGroup"
                                                type="primary"
                                                icon="ti-trash"
                                                @click="deleteGroup(scope.row)"
                                            ></el-button>
                                        </el-button-group>

                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </ns-paginate>
                </div>
            </ns-loader>
        </div>
    </simple-layout>
</template>

<script>

import NsPaginate from '../../partials/nsPaginate2';
import NsLoader from '../../partials/ns-vue-loader';
import CreateEditGroup from './create-edit-group-modal.vue';
import ModalForm from '../../partials/modal-form.js';
import {mapGetters} from 'vuex';
export default {

    components: {
        NsPaginate,
        NsLoader
    },

    props: {

    },

    data (){
        return {
            key: 0,
            groupNameBeingPatched: '',
            nsPaginateFilter: [
                {
                    key: 'name',
                    verbose: 'Name'
                }
            ],
            users: [],
            groups: [],
            nbGroups: 0,
        };
    },

    computed: {
        ...mapGetters('fundation', [
            'enableCreateGroup',
            'enableDeleteGroup',
            'enableDownloadCsvGroups',
            'getVerbose',
            'groupCreationAdditionnalValidators'
        ]),
        defaultModalSettings (){
            return {
                showCancelButton: true,
                showConfirmButton: true,
                closeOnClickModal: false,
            };
        },
    },

    watch: {
        '$store.getters.scopes': {
            handler() {
                this.$refs.groupPaginate.loadContent();
            },
            deep: true,
        },
        groups(val) {
            this.nbGroups = val.total_objects_count;
        }
    },

    created (){
        if(!this.$store.getters.enableGroupsSideBarMenu){
            this.$router.push('/');
        }
    },

    methods: {
        onDataFetched (response){
            this.$store.dispatch('fundation/updateArrayOfItems', {
                srcArray: this.users,
                targetArray: response.users
            });
        },
        customFiltersToApply (){
            return {ordering: 'name'};
        },

        openModalpatchGroup (group, onlyUsers=false){
            ModalForm.display(
                this,
                CreateEditGroup,
                {
                    group: group,
                    users: this.users,
                    edit: true,
                    getVerbose: this.getVerbose
                },
                `${this.getVerbose('group_modal_manage_user_group_title_beginning')} ${group.name} ${this.getVerbose('group_modal_manage_user_group_title_end')}`,
                this.patchGroup
            );

        },
        openModalCreateGroup (){

            ModalForm.display(
                this,
                CreateEditGroup,
                {
                    users: this.users,
                    getVerbose: this.getVerbose,
                    existingGroups: this.groups.results,
                    groupCreationAdditionnalValidators: this.groupCreationAdditionnalValidators
                },
                `${this.getVerbose('group_modal_create_group_title')}`,
                this.createGroup
            );
        },

        createGroup(data){
            return this.$store.dispatch('fundation/createGroup', {
                groupName: data.name,
                membersUid: data.members_uid,
            }).then((response) => {
                this.$notify.success({title: this.getVerbose('group_create_group_success_title'), message: this.getVerbose('group_create_group_success_message')});
                this.$refs.groupPaginate.loadContent();
            }).catch((e) => {
                this.$notify.error({title: this.getVerbose('group_create_group_failure_title'), message: this.getVerbose('group_create_group_failure_message')});

            });
        },


        deleteGroup(group) {
            this.$confirm(`${this.getVerbose('group_deletion_prompt_message_beginning')} ${group.name} ${this.getVerbose('group_deletion_prompt_message_end')}`, this.getVerbose('group_deletion_prompt_title'), {
                confirmButtonText: this.getVerbose('group_deletion_prompt_button_confirm'),
                cancelButtonText: this.getVerbose('group_deletion_prompt_button_cancel'),
                type: 'warning'
            }).then(() => {
                this.$store.dispatch('deleteItem', {
                    item: group,
                    model: 'groups'
                }).then((response) => {
                    this.$notify.success({
                        title: this.getVerbose('group_deletion_success_title'),
                        message: `${group.name} ${this.getVerbose('group_deletion_success_message')}`
                    });
                    this.$refs.groupPaginate.loadContent();
                }).catch((e) => {
                    this.$notify.error({
                        title: this.getVerbose('group_deletion_failure_title'),
                        message: this.getVerbose('group_deletion_failure_message')
                    });
                });
            });
        },
        groupNameValidator(value) {
            if (!value) {
                this.$notify.error({
                    message: this.getVerbose('group_modal_form_error_name_empty')
                });
                return false;
            }
            let regex = /[a-zA-Z0-9-]+/g;
            let match = value.match(regex);
            if(match === null || match.length > 1){
                this.$notify.error({
                    message: this.getVerbose('group_modal_form_error_syntax')
                });
                return false;
            }
            if(!this.edit && value.toUpperCase() !== this.groupNameBeingPatched.toUpperCase() && this.groups.results.find((g) => g.name.toUpperCase() === value.toUpperCase())){
                this.$notify.error({
                    message: this.getVerbose('group_modal_form_error_name_taken')
                });
                return false;
            }
            let validators = this.groupCreationAdditionnalValidators;
            for(let validator of validators){
                try{
                    validator(value);
                }
                catch(e){
                    // e should be the message thrown as an error in the validator
                    this.$notify.error({
                        message: e
                    });
                    return false;
                }
            }
            return true;
        },
        updateGroupName (group){
            this.groupNameBeingPatched = group.name;
            this.$prompt(this.getVerbose('group_update_group_name_prompt_message'), this.getVerbose('group_update_group_name_prompt_title'), {
                confirmButtonText: this.getVerbose('group_update_group_name_prompt_button_confirm'),
                cancelButtonText: this.getVerbose('group_update_group_name_prompt_button_cancel'),
                inputValue: group.name,
                inputPattern: /\w+/,
            }).then((res) => {
                if (this.groupNameValidator(res.value) === true) {
                    group.name = res.value;
                    this.patchGroup(group);
                }
            });
        },

        patchGroup (group){
            return this.$store.dispatch('patchItem', {
                item: {
                    url: group.url,
                    uid: group.uid,
                    name: group.name,
                    members_uid: group.members_uid,
                    can_view_users: group.members_uid,
                },
                model: 'groups'
            }).then((response) => {
                this.$notify.success({title: this.getVerbose('group_update_group_name_success_title'), message: `${this.getVerbose('group_update_group_name_success_message_beginning')}${group.name} ${this.getVerbose('group_update_group_name_success_message_end')}`});
                this.$refs.groupPaginate.loadContent();
            }).catch((e) => {
                this.$notify.error({title: this.getVerbose('group_update_group_name_failure_title'), message: `${this.getVerbose('group_update_group_name_failure_message_beginning')} ${group.name} ${this.getVerbose('group_update_group_name_failure_message_end')}`});

            });
        },
    },
};
</script>

<style lang="scss">
    .user-management-group{

        .add-button {
            display: flex;
            margin-left: auto;
            margin-right: 30px;
        }
        .ti-plus{
            font-size: 11px;
            position: absolute;
            top: 5px;
            right: 12px;
        }
    }
</style>



// WEBPACK FOOTER //
// node_modules/fundation-app-vuejs/src/components/usersManagement/group/index.vue